import { Box } from '@mui/material';
import { getCellStyle } from '../../../Utils/DecideColor';
import { RatePlanOrAttributesColumn } from '../../../Utils/RatePlanColumn';
import { Input } from 'reactstrap';
import StatusBadge from '../../../Customers/StatusBadge';
import { formatDateForDisplay,formatCellValue } from '../../../Utils/UtilityFunctions';

export const offerColumns = (grant, charge, usage, globalScope, allStartDate, allEndDate, rolename, selectAllOffer, setSelectAllOffer, offers, setSelectedOffer, selectedOffer, checkboxRef, isMobile) => {
    const columns = [
        {
            accessorKey: 'checkbox',
            header: 'checkbox',
            muiTableHeadCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
            muiTableBodyCellProps: { sx: { order: -2, paddingRight: '0px', maxWidth: "10px" } },
            Header: ({ row }) => (
                <Input type="checkbox" ref={checkboxRef} className='rv-table-checkbox' checked={selectAllOffer} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onChange={() => {
                    setSelectAllOffer(!selectAllOffer)
                    if (!selectAllOffer) {
                        setSelectedOffer(offers)
                    }
                    else {
                        setSelectedOffer([])
                    }
                }} />
            ),
            enableColumnFilter: false,
            enableColumnActions: false,
            enableColumnDragging: false,
            Cell: ({ row }) => (
                <Input type="checkbox" className='rv-table-checkbox' checked={selectedOffer.some(p => p.offerCode === row.original.offerCode)} style={{ borderWidth: '2px', borderColor: '#000', borderRadius: '0' }} onChange={() => {
                    handleCheckboxChange(row, selectedOffer, setSelectedOffer)
                }
                } />
            ),
            size: 50
        },

        {
            accessorKey: 'offerName',
            id: 'offerName',
            header: 'Offer Name',
            size: 200
        },
        {
            accessorKey: 'offerCode',
            id: 'offerCode',
            header: 'Code',
        },
        {
            accessorFn: (offer, index) => `${grant[index]} ${charge[index]} ${usage[index]} `,
            id: 'ratePlan',
            header: 'Rate Plan',
            Cell: ({ cell }) => {
                const attributes = cell.getValue();
                const [grant, charge, usage] = attributes?.split(' ');
                return [grant, charge, usage]?.map((val) => { return val ? <span className='me-1'><StatusBadge value={val} /></span> : null; })
                // return (<RatePlanOrAttributesColumn grant={grant} charge={charge} usage={usage} offerOrPolicy={false} />);
            },
            size: 240
        },
        {
            accessorFn: (offer, index) => `${globalScope[index]}`,
            id: 'globalScope',
            header: 'Global Scope',
            size: 200
        },
        {
            accessorFn: (offer, index) => `${formatDateForDisplay(allStartDate[index])}`,
            id: 'offerStartsOn',
            header: 'Offer Starts On',
            size: 230
        },
        {
            accessorFn: (offer, index) => `${formatDateForDisplay(allEndDate[index])}`,
            id: 'offerEndsOn',
            header: 'Offer Ends On',
            size: 230
        },
    ];

    if (rolename === 'telcoAdmin') {
        columns.push({
            accessorKey: 'policySpecification',
            header: 'PolicySpecification',
             Cell: ({ cell }) => {
                const policySpecification = cell.getValue();
                return policySpecification ? policySpecification : '-'
            },
            size: 250
        });
    }

    return columns;
};

export const grantsColumnData = () => {
    const grantsColumn = [
        {
            accessorKey: 'resourceName',
            header: 'Resource Name',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => `${row?.type === 2 ? "Recurring" : "One Time"}`,
            header: 'Type'
        },
        {
            accessorKey: 'amount',
            header: 'Amount',
            size: 200,
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => `${row.prorate === false ? "False" : "True"}`,
            header: 'Prorate'
        },
        {
            accessorFn: (row) => `${(row.overridable) ? "True" : "False"}`,
            header: 'Override'
        },
    ];
    return grantsColumn;
};

export const chargesColumnData = () => {
    const chargesColumn = [
        {
            accessorKey: 'resourceName',
            header: 'Resource Name',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => `${row?.type === 2 ? "Recurring" : "One Time"}`,
            header: 'Type'
        },
        {
            accessorKey: 'amount',
            header: 'Price',
            size: 200,
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => `${row.prorate === false ? "False" : "True"}`,
            header: 'Prorate'
        },
        {
            accessorFn: (row) => `${(row.overridable) ? "True" : "False"}`,
            header: 'Override'
        },
    ];
    return chargesColumn;
};

export const usageRatePlanColumnData = () => {
    const usageRatePlanColumn = [
        {
            accessorKey: 'eventType',
            header: 'Event Type',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => {
                `${row?.balanceImpacts?.[0]?.resourceName}`
            },
            header: 'Resource Name',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'uomName',
            header: 'UOM',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorKey: 'priority',
            header: 'Priority',
            size: 200,
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (row) => `${row?.balanceImpacts?.[0]?.rateTier[0]?.perUnitRate}`,
            header: 'Per Unit Rate',
             Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
    ];
    return usageRatePlanColumn;
};

export const handleCheckboxChange = (row, selectedOffer, setSelectedOffer) => {
    let isChecked = selectedOffer.some(p => p.offerCode === row.original.offerCode);
    let updatedSelectedOffer = isChecked
        ? selectedOffer.filter(p => p.offerCode !== row.original.offerCode)
        : [...selectedOffer, row.original];
    setSelectedOffer(updatedSelectedOffer);
};
